import type { SlotKey } from '@/apilib';
import type { EditorPermissions } from './editorPermissionsEntryPoint';

export const EditorPermissionsApiKey: SlotKey<EditorPermissions> = {
  name: 'EditorPermissionsApi',
  public: true,
};
